import BatchUpdates from '@/pages/batchUpdatesAdmin/BatchUpdatesAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/batch-updates')({
  component: () => <BatchUpdatesLayout />,
  // component: () => <IFramePage url="mass-update.html" />,
})

const BatchUpdatesLayout = () => {
  return (
    <>
      <BatchUpdates />
      <Outlet />
    </>
  )
}
